// extracted by mini-css-extract-plugin
export default {"bold":"ModalHeader-module__[local]___M+9iF"};